/*eslint eqeqeq: "off"*/
import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  Box,
  Card,
  TableBody,
  TableCell,
  TableRow,
  makeStyles,
  IconButton,
} from "@material-ui/core";
import { Edit as EditIcon, Trash2 as DeleteIcon } from "react-feather";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  deleteSingleDetails,
  editSingleDetails,
  passOrderDetails,
  getProductListOrderwise,
} from "./_orderBook_Action";
import commanTable from "../../components/commanTable";
import ToastNotify from "../../components/ToastNotify";
import moment from "moment";
import { getProductStoneDetails } from "../product/_product_Action";
import { getAttributeSaveValue } from "../purchase_Invoice/_purchase_Action";
import DeleteDialog from "src/components/DeleteDialog";

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    marginRight: theme.spacing(2),
  },
}));

const headCells = [
  { id: "orderDate", label: "Order Date" },
  { id: "platformName", label: "Platform Name" },
  { id: "platformAccountEmailId", label: "Platform Account Email" },
  { id: "platformOrderNo", label: "Platform Order No" },
  { id: "customerId", label: "Customer Name" },
  { id: "deliveryDay", label: "Delivery Day" },
  { id: "editProductOrder", label: "ProductList", disableSorting: true },
  { id: "edit", label: "Edit", disableSorting: true },
  { id: "delete", label: "Delete", disableSorting: true },
];

const OrderBookList = ({ className, TableData, filterFn, ...rest }) => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dialogopen, setDialogOpen] = React.useState(false);
  const [deleteRecord, setDeleteRecord] = React.useState("");

  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterPagingAndSorting,
  } = commanTable(TableData, headCells, filterFn);

  const editDetails = (id, data) => {
    dispatch(editSingleDetails(id, data));
    navigate("./edit", { replace: false });
  };

  const addEditProductOrder = async (orderid, data) => {
    await dispatch(getAttributeSaveValue("", "", "", orderid));
    await dispatch(getProductStoneDetails("", "", "", orderid));
    await dispatch(passOrderDetails(orderid, data));
    await dispatch(
      getProductListOrderwise(orderid, navigate, "./add_sell_order")
    );
  };
  const openDialog = (id) => {
    setDeleteRecord(id);
    setDialogOpen(!dialogopen);
  };
  const confirmDialog = () => {
    dispatch(deleteSingleDetails(deleteRecord));
  };

  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <ToastNotify />
      <PerfectScrollbar>
        <Box minWidth={1050}>
          <TblContainer>
            <TblHead />
            {TableData.length > 0 ? (
              <TableBody>
                {/* {TableData.slice(0, limit).map((row) => ( */}
                {recordsAfterPagingAndSorting().map((row) => (
                  <TableRow hover key={row.id}>
                    <TableCell>
                      {moment(row.orderDate).format("DD-MM-YYYY")}
                    </TableCell>
                    <TableCell>{row.platformName}</TableCell>
                    <TableCell>{row.accountEmailId}</TableCell>
                    <TableCell>{row.platformOrderNo}</TableCell>
                    <TableCell>{row.customerName}</TableCell>
                    <TableCell>{row.deliveryDay}</TableCell>
                    <TableCell width="5%">
                      <IconButton
                        size="small"
                        onClick={() => addEditProductOrder(row.id, row)}
                      >
                        <EditIcon />
                      </IconButton>
                    </TableCell>

                    <TableCell width="5%">
                      <IconButton
                        size="small"
                        onClick={() => editDetails(row.id, row)}
                      >
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell width="5%">
                      <IconButton
                        size="small"
                        onClick={() => openDialog(row.id)}
                      >
                        <DeleteIcon />
                        {deleteRecord == row.id ? (
                          <DeleteDialog
                            openDialog={openDialog}
                            confirmDialog={confirmDialog}
                            dialogopen={dialogopen}
                          />
                        ) : (
                          ""
                        )}
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            ) : (
              <caption>No Record Found...</caption>
            )}
          </TblContainer>
        </Box>
      </PerfectScrollbar>
      <TblPagination />
    </Card>
  );
};

OrderBookList.propTypes = {
  className: PropTypes.string,
  //TableData: PropTypes.array.isRequired
};

export default OrderBookList;
